import { STANDARD_DISCLOSURE, type Partner } from "./types";

export const urbanLeague: Partner = {
  slug: "urban-league",
  name: "National Urban League",
  fullName: "National Urban League affiliate housing programs",
  path: "/partners/urban-league",
  externalUrl: "https://nul.org/",
  externalLabel: "Find your local Urban League affiliate",

  title: "Urban League Housing Programs: Counseling and Down Payment Help (2026)",
  description:
    "National Urban League affiliates run HUD-approved housing counseling, homebuyer education, and in many cities administer local down payment assistance. Who it fits, what affiliates actually offer, and how it pairs with stacking grants and DPA.",
  h1: "Urban League affiliates: counseling and, in many cities, the DPA money itself",

  cardHeadline: "Counseling and local down payment help in one place",
  cardBody:
    "Urban League affiliates operate in cities across the country. Many are HUD-approved counseling agencies, and a number of them also administer the local down payment assistance programs directly — which means the same office can fix your file and hand you the application.",
  cardPoints: ["Free HUD-approved counseling", "Homebuyer education", "Some administer local DPA", "City-by-city affiliates"],

  barriers: ["credit", "savings", "certificate", "income_limits"],
  hubSummary:
    "City-level affiliates offering HUD-approved counseling, homebuyer education, and in many markets the local down payment assistance program itself.",

  fits: [
    "You live in a metro with an active Urban League affiliate.",
    "You want counseling and a shot at local assistance from the same organization.",
    "Your income sits below area limits for city or county programs.",
    "You want in-person help rather than an online course.",
  ],
  doesNotFit: [
    "There is no affiliate near you — use HUD's agency locator instead.",
    "You need to close in the next few weeks.",
    "You're buying an investment property.",
  ],
  steps: [
    { title: "Find your local affiliate", detail: "Every affiliate is an independent nonprofit. What it offers — counseling, education, DPA administration — is set locally." },
    { title: "Ask what housing services it runs", detail: "Not every affiliate does housing. Ask specifically about HUD-approved counseling and whether they administer any purchase assistance." },
    { title: "Complete counseling and education", detail: "Free counseling plus the certificate most assistance programs require." },
    { title: "Apply for local assistance through them", detail: "Where the affiliate administers DPA, they take the application and know the current funding status." },
    { title: "Stack the rest", detail: "Local DPA is one layer. Run your Stack to see what state, employer, and national programs sit on top of it." },
  ],
  compareLabel: "Urban League affiliate",
  compare: [
    { factor: "What you get", partner: "Counseling, education, sometimes DPA administration", stack: "A list of grants and DPA you may qualify for" },
    { factor: "Cost", partner: "Free counseling; course fees vary by affiliate", stack: "Free" },
    { factor: "Coverage", partner: "Only where an affiliate operates", stack: "Nationwide by ZIP" },
    { factor: "Timeline", partner: "Weeks to months", stack: "Minutes" },
    { factor: "Provides money", partner: "Sometimes, via local programs", stack: "Points you to program dollars" },
    { factor: "Best used", partner: "When you have an affiliate nearby", stack: "Always, first" },
  ],
  faqs: [
    { q: "Do all Urban League affiliates offer housing counseling?", a: "No. Affiliates are independent and each chooses its programs. Some run full HUD-approved housing counseling departments; others focus on jobs, education, or health. Call and ask before you plan around it." },
    { q: "Can the Urban League give me down payment money?", a: "Some affiliates administer city or county down payment assistance, which means they process the application and disburse funds under that program's rules. The money is the program's, not the affiliate's, and it runs out when the program's allocation runs out." },
    { q: "Is it only for Black homebuyers?", a: "No. Urban League affiliates serve everyone in the communities they operate in, and HUD-approved counseling cannot be restricted by race." },
    { q: "How do I know if their education certificate counts?", a: "Ask your assistance program for its approved-provider list, then confirm the affiliate is on it. Certificates from the wrong provider are the most common avoidable delay we see." },
    { q: "Does Home Approach get paid for this referral?", a: "No. Affiliates that both counsel and administer DPA are unusually useful, so we name them." },
  ],
  disclosure: STANDARD_DISCLOSURE("The National Urban League"),
};
